import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouteModule } from '../app.route';
import { SharedModule } from '../shared/shared.module';
import { LayoutComponent } from './components/layout/layout.component';
import { NavComponent } from './components/nav/nav.component';


export const COMPONENTS = [
  LayoutComponent,
  NavComponent
]

@NgModule({
  imports: [
    CommonModule,
    RouteModule,
    FormsModule,
    SharedModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class MainModule {
  static forRoot() {
    return {
      ngModule: MainModule
    };
  }
}
